let initialized = false;

export function initMetaPixel(metaPixelId: string) {
  if (initialized || !metaPixelId) {
    return;
  }

  console.log("Initializing Meta Pixel:", metaPixelId);

  const script = document.createElement("script");
  script.innerHTML = `
    !function(f,b,e,v,n,t,s)
    {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
        n.callMethod.apply(n,arguments):n.queue.push(arguments)};
        if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
        n.queue=[];t=b.createElement(e);t.async=!0;
        t.src=v;s=b.getElementsByTagName(e)[0];
        s.parentNode.insertBefore(t,s)}(window, document,'script',
        'https://connect.facebook.net/en_US/fbevents.js');
    fbq('init', '${metaPixelId}');
    fbq('track', 'PageView');
    `;
  document.head.prepend(script);

  const noScript = document.createElement("noscript");
  noScript.innerHTML = `<img height="1" width="1" style="display:none" alt="" src="https://www.facebook.com/tr?id=${metaPixelId}&ev=PageView&noscript=1"/>`;
  document.body.prepend(noScript);

  initialized = true;
}

export function isMetaPixelInitialized(): boolean {
  return initialized;
}

